import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { loginUser } from "../util/wordywhiz";
import { useAuth } from "../context/AuthContext";

function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setLoggedIn } = useAuth();
  const prefill = location.state?.userData || {};

  const [form, setForm] = useState({
    username: prefill.username || "",
    password: prefill.password || "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  function changeHandler(e) {
    setForm((curr) => ({ ...curr, [e.target.name]: e.target.value }));
  }

  async function submitHandler(e) {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    try {
      const data = await loginUser(form.username, form.password);
      setLoggedIn(data);
      navigate("/wordy-whiz/my-dictionaries");
    } catch {
      setError("Invalid username or password.");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="study-header">
        <p className="study-eyebrow">Wordy Whiz</p>
        <h1>Log In</h1>
      </div>

      {error && <p className="auth-error">{error}</p>}

      {isLoading ? (
        <div className="dict-spinner" />
      ) : (
        <form className="auth-form" onSubmit={submitHandler}>
          <label className="auth-field">
            <span className="ww-label">Username</span>
            <input
              className="auth-input"
              name="username"
              value={form.username}
              onChange={changeHandler}
              autoCapitalize="none"
              required
            />
          </label>
          <label className="auth-field">
            <span className="ww-label">Password</span>
            <input
              className="auth-input"
              type="password"
              name="password"
              value={form.password}
              onChange={changeHandler}
              required
            />
          </label>
          <div className="auth-actions">
            <button type="submit" className="ww-btn ww-btn--accent">Log In</button>
            <Link to="/wordy-whiz/signup" className="ww-btn ww-btn--secondary">Sign Up</Link>
          </div>
        </form>
      )}
    </div>
  );
}

export default Login;
